/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：528
 */

module.exports = {
  imageMallItem: "style_imageMallItem__mA9hN",
  selected: "style_selected__1M-fq",
  infoArea: "style_infoArea__kyZRn",
  btn: "style_btn__2G7hV",
  select: "style_select__Z9UVy",
  unselect: "style_unselect__G3KWS",
  playArea: "style_playArea__3at9K",
  nameArea: "style_nameArea__1q0gL",
  materialTypeIcon: "style_materialTypeIcon__28qGe",
  groupIcon: "style_groupIcon__Jton9",
  add: "style_add__2ckJQ"
}
